"use strict";

import http from "@/http";

const BASE_NAME = "notifications";

const list = async () => {
  const response = await http.get(`/${BASE_NAME}`);
  return response.data;
};

const remove = async id => {
  const response = await http.delete(`/${BASE_NAME}/${id}`);
  return response.data;
};

const markAsRead = async ids => {
  const response = await http.put(`/${BASE_NAME}/markAsRead`, { ids });
  return response.data;
};

const getPendingRates = async () => {
  const response = await http.get(`/${BASE_NAME}/pending-rates`);
  return response.data;
};

const getPendingApprovals = async () => {
  const response = await http.get(`/${BASE_NAME}/pending-approvals`);
  return response.data;
};

const getSecurityNotifications = async () => {
  const response = await http.get(`/${BASE_NAME}/approvals`);
  return response.data;
};

const getApprovalRequestsList = async () => {
  const response = await http.get(`${BASE_NAME}/approval-requests`);
  return response.data;
};

const getRequestAccess = async () => {
  const response = await http.get(`${BASE_NAME}/request-access`);
  return response.data;
};

export default {
  list,
  remove,
  markAsRead,
  getPendingRates,
  getPendingApprovals,
  getSecurityNotifications,
  getApprovalRequestsList,
  getRequestAccess
};
